<template>
	<div class="single-machine" v-if="currentPage">
		<section class="machine-header bg-light">
			<div class="main-content">
				<div class="title-line">
					<h1 v-html="currentPage.title.rendered"></h1>
					<wpLink 
                    :url="archive" 
					:type="true"
                    v-html="'Se hele maskinparken'" />
				</div>
				<template v-if="currentPage.acf.facts">
					<div class="machine-info">
						<p class="intro" v-if="currentPage.acf.intro" v-html="currentPage.acf.intro"></p>
						<div class="machine-facts">
							<div class="facts-item" v-if="currentPage.acf.facts.model">
								<p class="label" v-html="'Modell'"></p>
								<p v-html="currentPage.acf.facts.model"></p>
							</div>
							<div class="facts-item" v-if="currentPage.acf && currentPage.acf._category">
								<p class="label">Type</p>
								<Categories
										:categories="currentPage.acf._category" :taxonomy="'machines_cat'" :link="false"/>
							</div>
							<div class="facts-item" v-if="currentPage.acf.facts.capability">
								<p class="label" v-html="'Kapasitet'"></p>
								<p v-html="currentPage.acf.facts.capability"></p>
							</div>
						</div>
					</div>
				</template>
			</div>
		</section>
		<section class="main-content machine-main">
			
			<div class="machine-content">

				<section class="machine-gallery" v-if="currentPage.acf.gallery">
					<gallery :data="currentPage.acf.gallery"></gallery>
				</section>
				<section class="machine-gallery" v-if="!currentPage.acf.gallery">
					<WpImage  
                    :data="currentPage.featured_image_src" 
                    size="extra_large" 
                    background
                    caption
                    class="wide-image"
                    placeholder
                    lazy  />
				</section>
				
			</div>

		</section>
	</div>
	<div v-else class="nothing single-page"></div>
</template>

<script>

import gallery from '@/components/blocks/Gallery'
import wpLink from '@/components/navigation/WpLink'
import Categories from '@/components/blocks/CategoriesBlock'
import WpImage from '@/components/elements/WpImage'

export default {
	name: 'single-machine',
	data(){
		return {
			type: null,
			archive: this.$route.meta.archive,
		}
	},
	components:{
		gallery,
		wpLink,
		Categories,
		WpImage
	},
	computed:{
		
	},
}
</script>

<style>
</style>

